import { render, staticRenderFns } from "./ylfw_edit.vue?vue&type=template&id=cb5c63be&scoped=true&"
import script from "./ylfw_edit.vue?vue&type=script&lang=js&"
export * from "./ylfw_edit.vue?vue&type=script&lang=js&"
import style0 from "./ylfw_edit.vue?vue&type=style&index=0&id=cb5c63be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5c63be",
  null
  
)

export default component.exports